// extracted by mini-css-extract-plugin
export var parallax = "parallax-module--parallax--Kp-49";
export var parallaxContainer = "parallax-module--parallaxContainer--MWpKU";
export var text = "parallax-module--text--MZwjA";
export var caption = "parallax-module--caption--Zztkq";
export var caption2 = "parallax-module--caption2--5fohM";